export default {
    title: 'E-Mail an Ansprechpersonen',
    maxProcessesForCreatorUserMail: 'Es können max. {max} Mails gleichzeitig verschickt werden.',
    sendingCountMails: 'Es werden {count} E-Mails an Ansprechpersonen verschickt.|Es wird {count} E-Mail an Ansprechpersonen verschickt.|Es werden {count} E-Mails an Ansprechpersonen verschickt.',

    showHelp: 'Hilfe einblenden',
    hideHelp: 'Hilfe ausblenden',

    sendCreatorUserMail: 'E-Mail an Ansprechpersonen senden',

    creatorUserMailSentSuccessfully: 'E-Mail an Ansprechpersonen erfolgreich gesendet',
    errorOnSendingCreatorUserMail: 'Fehler beim Senden der E-Mail an den Ansprechpersonen',
}